import { render, staticRenderFns } from "./meio-ambiente.vue?vue&type=template&id=9c702568&"
import script from "./meio-ambiente.vue?vue&type=script&lang=js&"
export * from "./meio-ambiente.vue?vue&type=script&lang=js&"
import style0 from "./meio-ambiente.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports